import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PAS_X,FPAS_X, FPAS, CLOSE_PA, PA_LINES, PA_LINES2, PA_LINES3, PA_LINES4, PA_LINES5, PA_LINES6, EMPLOYEES, SEND2APPRAISER, MPA_LINES, MPA_LINES2, MPA_LINES4 } from 'helpers/url_helper';
import * as url from "../../helpers/url_helper"
 
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import Timeline from './Timeline';

    const ApproveFullTermsDetails = () => {
        const {id} = useParams();
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [apType , setApType] = useState(['Annual', 'Probation'])
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')
        const [ipaStatus, setIpaStatus] = useState('')
        const [seniormanagerstatus, setSeniorManagerStatus] = useState('')
        const [directorStatus, setDirectorStatus] = useState('')
        const [ipaDate, setIpaDate] = useState('')
        const [ipaPerformanceYear, setIpaPerformanceYear] = useState('')
        const [ipaConvert, setIpaConvert] = useState('')
        const [appraisalPeriod, setAppraisalPeriod] = useState('')
        const [appraiserNo, setAppraiserNo] = useState('')
        const [appraiserName, setAppraiserName] = useState('')
        const [appraiserTitle, setAppraiserTitle] = useState('')
        const [documentType, setDocumentType] = useState('')
        const [departmentCode, setDepartmentCode] = useState('')
        const [performanceType, setPerformanceType] = useState('')
        const [cycle, setCycle] = useState('')
        const [phase, setPhase] = useState('')
        const [lines, setLines] = useState([])
        const [lines2, setLines2] = useState([])

        const [whoAmI, setWhoAmI] = useState('')
        const [st, setSt] = useState('')

        const [aps, setAps] = useState(0)
        const [abs, setABs] = useState(0)
        const [oaps, setOAps] = useState(0)
        const [oabs, setOABs] = useState('')

        const [pps, setPps] = useState(0)
        const [pbs, setPbs] = useState(0)

        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [CompanyID, setCompanyID] = useState("")

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')

        const [isEdit, setIsEdit] = useState(false)
        const [lineSystemId, setLineSystemId] = useState('')

        const [kra, setKra] = useState('')
        const [target, setTarget] = useState('')
        const [kpi, setKpi] = useState('')
        const [resources, setResources] = useState('')

        const [cCode, setCCode] = useState('')
        const [competenciesDescription, setCompetenciesDescription] = useState('')
        const [attributes, setAttributes] = useState('')
        const [kpi2, setKpi2] = useState('')
        const [kra2, setKra2] = useState('')
        const [cat2, setCat2] = useState('')
        const [resources2, setResources2] = useState('')

        const [support, setSupport] = useState('')
        const [plannedResults, setPlannedResults] = useState('')
        const [actualResults, setActualResults] = useState('')

        const [goal, setGoal] = useState('')
        const [method, setMethod] = useState('')
        const [application, setApplication] = useState('')
        const [competencies, setCompetencies] = useState([])
        const [coachingMentorshipReceived, setCoachingMentorshipReceived] = useState('')
        const [actualCoachingResults, setActualCoachingResults] = useState('')
        const [gapsforrnextreview, setGapsforrnextreview] = useState('')
        const [lMCoachingMentoshipOffered, setLMCoachingMentoshipOffered] = useState('')
        const [lMActualCoachingResults, setLMActualCoachingResults] = useState('')
        const [lMGapsIdentified, setLMGapsIdentified] = useState('')
        const [shortTermDevelopmentGoals, setShortTermDevelopmentGoals] = useState('')
        const [shortTermLearningMethods, setShortTermLearningMethods] = useState('')
        const [shortTermApplication, setShortTermApplication] = useState('')
        const [lTCareerDevelopmentGoals, setLTCareerDevelopmentGoals] = useState('')
        const [lTLearningMethods, setLTLearningMethods] = useState('')
        const [lTApplicationOutcome, setLTApplicationOutcome] = useState('')
        const [lTTimescale, setLTTimescale] = useState('')


        const [accomplishments, setAccomplishments] = useState('')
        const [percentageRating, setPercentageRating] = useState(0)

        const [paLines1, setpaLines1] = useState([])
        const [paLines2, setpaLines2] = useState([])
        const [paLines3, setpaLines3] = useState([])
        const [paLines4, setpaLines4] = useState([])
        const [paLines5, setpaLines5] = useState([])
        const [paLines6, setpaLines6] = useState([])

        const [startDate, setStartDate] = useState('');
        const [endDate, setEndDate] = useState('');
        const [type, setType] = useState('');
        const [actionType, setActionType] = useState('');
        const [acType , setAcType] = useState(['Confirm probation', 'Extend probation', '100-day plan', 'Termination of contract', 'Confirm Appraisal',])

        const [modal_pa1, setmodal_pa1] = useState(false)
        const [modal_pa2, setmodal_pa2] = useState(false)
        const [modal_pa3, setmodal_pa3] = useState(false)
        const [modal_pa4, setmodal_pa4] = useState(false)
        const [modal_pa5, setmodal_pa5] = useState(false)
        const [modal_pa6, setmodal_pa6] = useState(false)
        const [modal_fpa1, setmodal_fpa1] = useState(false)
        const [modal_fpa2, setmodal_fpa2] = useState(false)
        const [modal_fpa3, setmodal_fpa3] = useState(false)
        const [modal_fpa4, setmodal_fpa4] = useState(false)

        const [majorsuccesses, setMajorsuccesses] = useState('')
        const [personalConstraint, setPersonalConstraint] = useState('')
        const [oraganizationalConstraint, setOraganizationalConstraint] = useState('')
        const [solutionstoweakness, setSolutionstoweakness] = useState('')
        const [appraiseeCommentsFullTerm, setAppraiseeCommentsFullTerm] = useState('')
        const [appraiserCommentsFullTerm, setAppraiserCommentsFullTerm] = useState('')
        const [seniorManagerCommentsFullTerm, setSeniorManagerCommentsFullTerm] = useState('')
        const [directorCommentsFullTerm, setDirectorCommentsFullTerm] = useState('')
        const [suggestedaction, setSuggestedAction] = useState('')

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_fpa1 = () => {
            setmodal_fpa1(!modal_fpa1);
            removeBodyCss();
        }
        const tog_fpa2 = () => {
            setmodal_fpa2(!modal_fpa2);
            removeBodyCss();
        }        
        const tog_fpa3 = () => {
            setmodal_fpa3(!modal_fpa3);
            removeBodyCss();
        }
        const tog_fpa4 = () => {
            setmodal_fpa4(!modal_fpa4);
            removeBodyCss();
        }
        const tog_pa1 = () => {
            setmodal_pa1(!modal_pa1);
            removeBodyCss();
        }
        const tog_pa2 = () => {
            setmodal_pa2(!modal_pa2);
            removeBodyCss();
        }
        const tog_pa3 = () => {
            setmodal_pa3(!modal_pa3);
            removeBodyCss();
        }
        const tog_pa4 = () => {
            setmodal_pa4(!modal_pa4);
            removeBodyCss();
        }
        const tog_pa5 = () => {
            setmodal_pa5(!modal_pa5);
            removeBodyCss();
        }
        const tog_pa6 = () => {
            setmodal_pa6(!modal_pa6);
            removeBodyCss();
        }

        const clearData1 = () =>{
            setIsEdit(false)
            setKra('')
            setTarget('')
            setKpi('')
            setResources('')
            setLineSystemId('')
        }
        const clearData2 = () =>{
            setKpi2('')
            setKra2('')
            setCat2('')
            setLineSystemId('')
        }
        const clearData3 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setActualCoachingResults('')
            setCoachingMentorshipReceived('')
            setGapsforrnextreview('')
        }
        const clearData4 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setLMGapsIdentified('')
            setLMActualCoachingResults('')
            setLMCoachingMentoshipOffered('')
        }
        const clearData5 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setShortTermDevelopmentGoals('')
            setShortTermLearningMethods('')
            setShortTermApplication('')
        }
        const clearData6 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setLTCareerDevelopmentGoals('')
            setLTLearningMethods('')
            setLTApplicationOutcome('')
            setLTTimescale('')
        }
    
        const savePA1 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                Accomplishments  : accomplishments,
                PercentageRating   : parseInt(percentageRating)
            }           
            axios.patch(`${PA_LINES}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_pa1()
                clearData1()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const savePA2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                Accomplishments  : accomplishments,
                PercentageRating   : parseInt(percentageRating)
            }            
            axios.patch(`${PA_LINES2}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_pa2()
                clearData2()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const remove3 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PA_LINES3}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PA line 3 removed successfully')
                tog_pa3()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const remove4 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PA_LINES4}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PA line 4 removed successfully')
                tog_pa4()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const remove5 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PA_LINES5}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PA line 5 removed successfully')
                tog_pa5()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const remove6 = ()=>{

            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            axios.delete(`${PA_LINES6}(${lineSystemId})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('PA line 6 removed successfully')
                tog_pa6()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleAddLine3 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            const data = {
                "DocumentNo"                : ipaNo,
                "CoachingMentorshipReceived": coachingMentorshipReceived,
                "ActualCoachingResults"     : actualCoachingResults,
                "Gapsforrnextreview"        : gapsforrnextreview,
            }            
            axios.post(`${PA_LINES3}?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Staff Coaching and Mentorship Line Added successfully')
                tog_pa3()
                clearData3
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const savePA3 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "CoachingMentorshipReceived"  : coachingMentorshipReceived,
                "ActualCoachingResults"   : actualCoachingResults,
                "Gapsforrnextreview" : gapsforrnextreview
            }            
            axios.patch(`${PA_LINES3}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('All Staff coaching and mentoring Line updated')
                tog_pa3()
                clearData3()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleAddLine4 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            const data = {

                "DocumentNo"                : ipaNo,
                "LMCoachingMentoshipOffered": lMCoachingMentoshipOffered,
                "LMActualCoachingResults"   : lMActualCoachingResults,
                "LMGapsIdentified"          : lMGapsIdentified
            }            
            axios.post(`${PA_LINES4}?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Line Managers Coaching and Mentorship Line Added successfully')
                tog_pa4()
                clearData4
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleAddLine5 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            const data = {

                "DocumentNo"                : ipaNo,
                "ShortTermDevelopmentGoals": shortTermDevelopmentGoals,
                "ShortTermLearningMethods" : shortTermLearningMethods,
                "ShortTermApplication"     : shortTermApplication
            }            
            axios.post(`${PA_LINES5}?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Short Term Development Goal Added successfully')
                tog_pa5()
                clearData5
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const handleAddLine6 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            const data = {

                "DocumentNo"              : ipaNo,
                "LTCareerDevelopmentGoals": lTCareerDevelopmentGoals,
                "LTLearningMethods"       : lTLearningMethods,
                "LTApplicationOutcome"    : lTApplicationOutcome,
                "LTTimescale"             : formatDate(lTTimescale[0])
            }            
            axios.post(`${PA_LINES6}?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Long Term Development Goal Added successfully')
                tog_pa6()
                clearData6
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const savePA4 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "LMCoachingMentoshipOffered"  : lMCoachingMentoshipOffered,
                "LMActualCoachingResults"     : lMActualCoachingResults,
                "LMGapsIdentified"            : lMGapsIdentified
            }            
            axios.patch(`${PA_LINES4}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Line Manager coaching and mentoring Line updated')
                tog_pa4()
                clearData4()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const savePA5 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "ShortTermDevelopmentGoals"  : shortTermDevelopmentGoals,
                "ShortTermLearningMethods"   : shortTermLearningMethods,
                "ShortTermApplication"       : shortTermApplication
            }            
            axios.patch(`${PA_LINES5}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Short Term Development Goals Line updated')
                tog_pa5()
                clearData5()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const savePA6 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "LTCareerDevelopmentGoals": lTCareerDevelopmentGoals,
                "LTLearningMethods"       : lTLearningMethods,
                "LTApplicationOutcome"    : lTApplicationOutcome,
                "LTTimescale"             : formatDate(lTTimescale[0])
            }            
            axios.patch(`${PA_LINES6}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Long Term Development Needs Line updated')
                tog_pa6()
                clearData6()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const handleClickLineDetails1 = (k) =>{
            setIsEdit(true)
            tog_pa1()
            setKra(paLines1[k].KeyResultArea)
            setTarget(paLines1[k].PlannedTarget)
            setKpi(paLines1[k].KeyPerformanceIndicator)
            setResources(paLines1[k].resourcesandSupportRequired)
            setLineSystemId(paLines1[k].SystemId)
            setAccomplishments(paLines1[k].Accomplishments)
            setPercentageRating(paLines1[k].PercentageRating)
           
        }
        const handleClickLineDetails2 = (k) =>{
            tog_pa2()
            setLineSystemId(paLines2[k].SystemId)
            setKra2(paLines2[k].Competencetargetsforthisperiod)
            setCat2(paLines2[k].CriticalAttributestargetedundereachcompetence)
            setKpi2(paLines2[k].KeyPerformanceIndicator)
            setAccomplishments(paLines2[k].Accomplishments)
            setPercentageRating(paLines2[k].PercentageRating)
        }
        const handleClickLineDetails3 = (k) =>{
            setIsEdit(true)
            tog_pa3()
            setLineSystemId(paLines3[k].SystemId)
            setCoachingMentorshipReceived(paLines3[k].CoachingMentorshipReceived)
            setActualCoachingResults(paLines3[k].ActualCoachingResults)
            setGapsforrnextreview(paLines3[k].Gapsforrnextreview)           
        }

        
        const handleClickLineDetails4 = (k) =>{
            setIsEdit(true)
            tog_pa4()
            setLineSystemId(paLines4[k].SystemId)
            setLMCoachingMentoshipOffered(paLines4[k].LMCoachingMentoshipOffered)
            setLMActualCoachingResults(paLines4[k].LMActualCoachingResults)
            setLMGapsIdentified(paLines4[k].LMGapsIdentified)
        }
        const handleClickLineDetails5 = (k) =>{
            setIsEdit(true)
            tog_pa5()
            setLineSystemId(paLines5[k].SystemId)
            setShortTermDevelopmentGoals(paLines5[k].ShortTermDevelopmentGoals)
            setShortTermLearningMethods(paLines5[k].ShortTermLearningMethods)
            setShortTermApplication(paLines5[k].ShortTermApplication)
        }
        const handleClickLineDetails6 = (k) =>{
            setIsEdit(true)
            tog_pa6()
            setLineSystemId(paLines6[k].SystemId)
            setLTCareerDevelopmentGoals(paLines6[k].LTCareerDevelopmentGoals)
            setLTLearningMethods(paLines6[k].LTLearningMethods)
            setLTApplicationOutcome(paLines6[k].LTApplicationOutcome)
            setLTTimescale(paLines6[k].LTTimescale)
        }

        const reports = [
            {
                icon: "bx bx-copy-alt",
                title: "Competence Score",
                value: aps,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-archive-in",
                title: "Technical Score",
                value: abs,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-copy-alt",
                title: "Overall Assessment",
                value: oaps,
                badgeValue: "",
                color: "success",
                desc: "",
              }
          ];
         
  
        const fetchData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(FPAS + "("+ id +")?$expand=paLines1,paLines2,paLines3,paLines4,paLines5,paLines6&company="+ obj.activeCompany, HRConfig)
                .then(function(response){
                    setMajorsuccesses(response.data.Majorsuccesses)
                    setPersonalConstraint(response.data.PersonalConstraint)
                    setOraganizationalConstraint(response.data.OraganizationalConstraint)
                    setSolutionstoweakness(response.data.Solutionstoweakness)
                    setAppraiseeCommentsFullTerm(response.data.AppraiseeCommentsFullTerm)
                    setAppraiserCommentsFullTerm(response.data.AppraiserCommentsFullTerm)
                    setSeniorManagerCommentsFullTerm(response.data.SeniorManagerCommentsFullTerm)
                    setDirectorCommentsFullTerm(response.data.DirectorCommentsFullTerm)
                      //check who am i
                    if(response.data.EmployeeNo == obj.uid){ setWhoAmI('appraisee'); }else if(response.data.Appraiser == obj.uid){ setWhoAmI('appraiser');  }

                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.EmployeeNo}'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ 
                        setEmpName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setEmpTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.Appraiser}'&company='${obj.activeCompany}'`, HRConfig).then((r)=>{ 
                        setSupervisorName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setSupervisorTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    setEmpNo(response.data.EmployeeNo)
                
                    setSupervisorNo(response.data.Appraiser)
                    setDepartmentCode(response.data.DepartmentCode)
                    setIpaDate(response.data.Date)
                    setCycle(response.data.AppraisalCycle)
                    setIpaPerformanceYear(response.data.PerformanceYear)
                    setIpaStatus(response.data.Status)
                    setSeniorManagerStatus(response.data.SeniorManagerStatus)
                    setDirectorStatus(response.data.DirectorStatus)
                    setIpaConvert(response.data.ConvertToAppraisal)
                    setAppraisalPeriod(response.data.AppraisalPeriod)
                    setIpaNo(response.data.No)

                    setDocumentType(response.data.DocumentType)
                    setPerformanceType(response.data.PerformanceType)
                    setIpaDate(response.data.PostingDate)
                    setType(response.data.TypeofPerformanceAppraisal)
                    setActionType(response.data.SuggestedAction)
                    setStartDate(response.data.FromDate)
                    setEndDate(response.data.ToDate)
                    setPhase(response.data.Phase)
                    setpaLines1(response.data.paLines1)
                    setpaLines2(response.data.paLines2)
                    setpaLines3(response.data.paLines3)
                    setpaLines4(response.data.paLines4)
                    setpaLines5(response.data.paLines5)
                    setpaLines6(response.data.paLines6)

                    setAps(response.data.AverageOverallCompetencyScore.toFixed(2))
                    setABs(response.data.AverageOverallTechnicalScore.toFixed(2))
                    setOAps(response.data.OverallPerformanceAssessment.toFixed(2))
                    setOABs(response.data.OverallMidyearRemarks)
                    if(response.data.Phase == "Annual"){
                        setSt(3);
                    }else if(response.data.Phase == "Probation"){
                        setSt(3);
                    }else if(response.data.Phase == "Closed"){
                        setSt(5);
                    } 
                    setIsloading(false)
                }).catch(function (error) {
                    //toastr.error(error.response.data.error.message);
                    setUserError(true);
                    setIsloading(false)
                })
                .then(function () {
            });
        }
        const handleUpdatePA1 = () =>{
            setIsEdit(true)
            tog_fpa1()
        }
        useEffect(() => {
           fetchData();
        },[]);
        const handleUpdatePA2 = () =>{
            setIsEdit(true)
            tog_fpa2()
        }
        useEffect(() => {
           fetchData();
        },[]);
        const handleUpdatePA3 = () =>{
            setIsEdit(true)
            tog_fpa3()
        }
        useEffect(() => {
           fetchData();
        },[]);
        const handleUpdatePA4 = () =>{
            setIsEdit(true)
            tog_fpa4()
        }
        useEffect(() => {
           fetchData();
        },[]);
        const handleUpdatePA = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "AppraiseeCommentsFullTerm": AppraiseeCommentsFullTerm,
                "AppraiserCommentsFullTerm": AppraiserCommentsFullTerm,
                "SeniorManagerCommentsFullTerm": SeniorManagerCommentsFullTerm,
                "DirectorCommentsFullTerm" : DirectorCommentsFullTerm,
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Appraisal Comments saved')
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
        fetchData();
        },[]);


        const handleUpdateGeneralAssessment = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "Majorsuccesses"           : majorsuccesses,
                "PersonalConstraint"       : personalConstraint,
                "OraganizationalConstraint": oraganizationalConstraint,
                "Solutionstoweakness"      : solutionstoweakness,
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('General Assessment Questions saved')
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const saveFPA1 = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "AppraiseeCommentsFullTerm": appraiseeCommentsFullTerm,
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})?company=${obj.activeCompany}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Appraisee Comments saved')
                setIsloading(false)
                setmodal_fpa1(false) 
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const saveFPA2 = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "AppraiseeCommentsFullTerm": appraiseeCommentsFullTerm,
                "AppraiserCommentsFullTerm": appraiserCommentsFullTerm,
                "SuggestedAction"          : actionType
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Employee/Supervisor Comments saved')
                setIsloading(false)
                setmodal_fpa2(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const saveFPA3 = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "SeniorManagerCommentsFullTerm": seniorManagerCommentsFullTerm,
                "SuggestedAction"          : actionType
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Manager/Director Comments saved')
                setIsloading(false)
                setmodal_fpa3(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

        const saveFPA4 = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                "DirectorCommentsFullTerm"  : directorCommentsFullTerm,
                "SuggestedAction"           : actionType
            }
            setIsloading(true)
            axios.patch(`${url.FPAS}(${id})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Director Comments saved')
                setIsloading(false)
                setmodal_fpa4(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);
      
      
        const handleConfirmMidTermJointReview = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.CONFIRMMIDTERMJOINTREVIEW , JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    toastr.success(response.data.value)
                    history.push("/appraise-performance-appraisals")
                    fetchData()
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleApproveAppraisal = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.APPROVEFULLTERMAPPRAISAL+'?company='+CompanyID , JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    toastr.success(response.data.value)
                    history.push("/approve-fullterm-appraisals-list")
                    fetchData()
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }


        const handleConvertToFullYear = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.CONVERTMID2FULLYEAR , JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    toastr.success(response.data.value)
                    history.push("/performance-appraisals")
                    fetchData()
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleSendForApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.SENDIPA4APPROVAL , JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        //window.location.reload();
                        fetchData()
                    }else{
                        toastr.success("Could not Post IPA" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }
        const handleSendFulltermToAppraiser = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.SENDFULLTERMTOAPPRAISER , JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    toastr.success(response.data.value)
                    fetchData()
                    setIsloading(false)
                    history.push("/full-performance-appraisals")
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleClosePA = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CLOSE_PA , JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    //console.log(response)   
                    if(response.status == '204'){
                        toastr.success("Appraisal Closed"); 
                        //window.location.reload();
                        fetchData()
                    }else{
                        toastr.success("Could not Close" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }

        const handlePrint = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.PRINTAPPRAISAL, JSON.stringify(lNo), HRConfig).then((r)=>{
                fetch(r.data.value)
                .then(response => response.blob())
                .then(blob => {
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'yourPdfFile.pdf';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                });
            }).catch((e)=>{
                console.log(e)
            })
        }
        return (
            <LoadingOverlay
            active={isloading}
            spinner={<ClimbingBoxLoader />}
            text='Please wait...' >
            <div className="page-content">
            <MetaTags>
            <title>Full Term Performance Appraisal | BRIDGE</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title="Human Resource Management" breadcrumbItem="Full Term Performance Appraisal" />
                <div>
             
                    <Row>
                        <Col md={12}>
                            <Alert color={(ipaStatus == "Pending Approval")?`warning`: ((ipaStatus == "Open")?`danger`:`success`) }><strong>{ipaStatus}</strong></Alert>
                        </Col>
                    </Row>
               
                
                                <Modal isOpen={modal_pa1} toggle={tog_pa1} size='xl' centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Technical Job Deliverables</h5>
                                    <button type="button" onClick={() => { setmodal_pa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Result Area</label>
                                                <textarea rows={4} className="form-control" value={kra} onChange={(e)=>setKra(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={4} className="form-control" value={kpi} onChange={(e)=>setKpi(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Statement of targets to be achieved</label>
                                                <textarea rows={4} className="form-control" value={target} onChange={(e)=>setTarget(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Accomplishments</label>
                                                <textarea rows={4} className="form-control" value={accomplishments} onChange={(e)=>setAccomplishments(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Percentage Rating</label>
                                                <input type='number' className="form-control" value={percentageRating} onChange={(e)=>setPercentageRating(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_pa1() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    
                                    <button type="button" className="btn btn-success" onClick={savePA1}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>
                                <Modal isOpen={modal_pa2} toggle={tog_pa2} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Competence Targets</h5>
                                    <button type="button" onClick={() => { setmodal_pa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                              
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key result areas</label>
                                                <textarea rows={4} className="form-control" value={kra2} onChange={(e)=>setKra2(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={4} className="form-control" value={kpi2} onChange={(e)=>setKpi2(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Critical Areas Targetted</label>
                                                <textarea rows={4} className="form-control" value={cat2} onChange={(e)=>setCat2(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Accomplishments</label>
                                                <textarea rows={4} className="form-control" value={accomplishments} onChange={(e)=>setAccomplishments(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Percentage Rating</label>
                                                <input type='number' className="form-control" value={percentageRating} onChange={(e)=>setPercentageRating(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_pa2() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={savePA2}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_pa3} toggle={tog_pa3} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Coaching and Mentorship: All Staff</h5>
                                    <button type="button" onClick={() => { setmodal_pa3(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>What coaching/Mentorship did you receive in this period that facilitated your performance or learning?</label>
                                                <textarea rows={4} className="form-control" value={coachingMentorshipReceived} onChange={(e)=>setCoachingMentorshipReceived(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Actual Coaching Results: What was achieved/What was the impact?</label>
                                                <textarea rows={4} className="form-control" value={actualCoachingResults} onChange={(e)=>setActualCoachingResults(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Gaps: What are the key identified gaps for follow-up in the next review?</label>
                                                <textarea rows={4} className="form-control" value={gapsforrnextreview} onChange={(e)=>setGapsforrnextreview(e.target.value)} />
                                            </div>
                                        </Col>                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    {/* <button type="button" onClick={tog_pa3} className="btn btn-danger " data-dismiss="modal">Cancel</button> */}
                                    {!isEdit && <button type="button" className="btn btn-success" onClick={handleAddLine3}>Save Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-success" onClick={savePA3}>Update Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-danger" onClick={remove3}>Delete Line...</button>}
                                  </div>
                                  )}
                                </Modal>
        
                                
                                <Modal isOpen={modal_pa4} toggle={tog_pa4} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Coaching and Mentorship: Line Managers</h5>
                                    <button type="button" onClick={() => { setmodal_pa4(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>What coaching or mentorship did you offer to those reporting to you to facilitate their performance or learning?</label>
                                                <textarea rows={4} className="form-control" value={lMCoachingMentoshipOffered} onChange={(e)=>setLMCoachingMentoshipOffered(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Actual Coaching Results: What was achieved/What was the impact?</label>
                                                <textarea rows={4} className="form-control" value={lMActualCoachingResults} onChange={(e)=>setLMActualCoachingResults(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Gaps: What are the key identified gaps for follow-up in the next review?</label>
                                                <textarea rows={4} className="form-control" value={lMGapsIdentified} onChange={(e)=>setLMGapsIdentified(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    {/* <button type="button" onClick={tog_pa4} className="btn btn-danger " data-dismiss="modal">Cancel</button> */}
                                    {!isEdit && <button type="button" className="btn btn-success" onClick={handleAddLine4}>Save Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-success" onClick={savePA4}>Update Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-danger" onClick={remove4}>Delete Line...</button>}
                                  </div>
                                  )}
                                </Modal>
        
                                <Modal isOpen={modal_pa5} toggle={tog_pa5} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Training Needs: Short Term Development Goals</h5>
                                    <button type="button" onClick={() => { setmodal_pa5(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>What Learning and Development is required to support your current objectives and growth?</label>
                                                <textarea rows={4} className="form-control" value={shortTermDevelopmentGoals} onChange={(e)=>setShortTermDevelopmentGoals(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Learning Methods: How will the learning be achieved?</label>
                                                <textarea rows={4} className="form-control" value={shortTermLearningMethods} onChange={(e)=>setShortTermLearningMethods(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Application/Outcome: Please relate how the Learning and Development will be applied to the job/improve performance.</label>
                                                <textarea rows={4} className="form-control" value={shortTermApplication} onChange={(e)=>setShortTermApplication(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    {/* <button type="button" onClick={tog_pa5} className="btn btn-danger " data-dismiss="modal">Cancel</button> */}
                                    {!isEdit && <button type="button" className="btn btn-success" onClick={handleAddLine5}>Save Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-success" onClick={savePA5}>Update Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-danger" onClick={remove5}>Delete Line...</button>}
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_pa6} toggle={tog_pa6} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Training Needs: Long Term Development Goals</h5>
                                    <button type="button" onClick={() => { setmodal_pa6(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Career Development Goals</label>
                                                <textarea rows={4} className="form-control" value={lTCareerDevelopmentGoals} onChange={(e)=>setLTCareerDevelopmentGoals(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Learning Methods:</label>
                                                <textarea rows={4} className="form-control" value={lTLearningMethods} onChange={(e)=>setLTLearningMethods(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Application/Outcome:</label>
                                                <textarea rows={4} className="form-control" value={lTApplicationOutcome} onChange={(e)=>setLTApplicationOutcome(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Timescale:</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    value={lTTimescale}
                                                    onChange={(date)=>setLTTimescale(date)}
                                                    placeholder="YYYY-MM-DD"
                                                    options={{
                                                        dateFormat: "Y-m-d"
                                                    }} />
                                            </div>
                                        </Col>

                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    {/* <button type="button" onClick={tog_pa6} className="btn btn-danger " data-dismiss="modal">Cancel</button> */}
                                    {!isEdit && <button type="button" className="btn btn-success" onClick={handleAddLine6}>Save Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-success" onClick={savePA6}>Update Line Details...</button>}
                                    {isEdit && <button type="button" className="btn btn-danger" onClick={remove6}>Delete Line...</button>}
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_fpa1} toggle={tog_fpa1} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Appraisee Comments</h5>
                                    <button type="button" onClick={() => { setmodal_fpa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Appraisee Comments</label>
                                                <textarea rows={4} className="form-control" value={appraiseeCommentsFullTerm} onChange={(e)=>setAppraiseeCommentsFullTerm(e.target.value)} />
                                            </div>
                                        </Col>                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center"> 
                                    {isEdit && <button type="button" className="btn btn-success" onClick={saveFPA1}>Save Appraisee Comments...</button>}
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_fpa2} toggle={tog_fpa2} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Employee & Supervisor Comments</h5>
                                    <button type="button" onClick={() => { setmodal_fpa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Comments</label>
                                                <textarea rows={4} className="form-control" value={appraiseeCommentsFullTerm} onChange={(e)=>setAppraiseeCommentsFullTerm(e.target.value)} />
                                            </div>
                                        </Col>    
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Supervisor Comments</label>
                                                <textarea rows={4} className="form-control" value={appraiserCommentsFullTerm} onChange={(e)=>setAppraiserCommentsFullTerm(e.target.value)} />
                                            </div>
                                        </Col>    
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Suggested Action</label>
                                                <select className="form-select" value={actionType} onChange={(e)=>setActionType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {acType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                    </select>

                                            </div>
                                        </Col>    
                                                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center"> 
                                    {isEdit && <button type="button" className="btn btn-success" onClick={saveFPA2}>Save Employee and Supervisor Comments...</button>}
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_fpa3} toggle={tog_fpa3} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Manager/Director Comments</h5>
                                    <button type="button" onClick={() => { setmodal_fpa3(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Manager Comments</label>
                                                <textarea rows={4} className="form-control" value={seniorManagerCommentsFullTerm} onChange={(e)=>setSeniorManagerCommentsFullTerm(e.target.value)} />
                                            </div>
                                        </Col>    
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Suggested Action</label>
                                                <select className="form-select" value={actionType} onChange={(e)=>setActionType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {acType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                    </select>

                                            </div>
                                        </Col>    
                                                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center"> 
                                    {isEdit && <button type="button" className="btn btn-success" onClick={saveFPA3}>Save Manager/Director Comments...</button>}
                                  </div>
                                  )}
                                </Modal>

                                <Modal isOpen={modal_fpa4} toggle={tog_fpa4} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Director Comments</h5>
                                    <button type="button" onClick={() => { setmodal_fpa4(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Director Comments</label>
                                                <textarea rows={4} className="form-control" value={directorCommentsFullTerm} onChange={(e)=>setDirectorCommentsFullTerm(e.target.value)} />
                                            </div>
                                        </Col>    
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Suggested Action</label>
                                                <select className="form-select" value={actionType} onChange={(e)=>setActionType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {acType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                    </select>

                                            </div>
                                        </Col>    
                                                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center"> 
                                    {isEdit && <button type="button" className="btn btn-success" onClick={saveFPA4}>Save Director Comments...</button>}
                                  </div>
                                  )}
                                </Modal>
                
                <Row>
                    <Col  xl={3}>
                            <Timeline stage={st}/>
               

                        </Col>
               
                        <Col xl={9}>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Details</h5>
                            <CardBody>
                   
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle}  />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Full-term Details</h5>
                            <CardBody>
                     
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>No</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaNo}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Department Code</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={departmentCode}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Convert to PA</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaConvert}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Document Type</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={documentType}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Year</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaPerformanceYear}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Phase</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={phase}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaStatus}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaDate}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Type of Performance Appraisal</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={type}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={startDate}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={endDate}  />
                                        </div>
                                    </Col>
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">GENERAL ASSESSMENT</h5>
                                    <CardBody>
                         
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Highlight major successes and accomplishments attained during the period of review.</label>
                                            <textarea rows={4} className="form-control" value={majorsuccesses} onChange={(e)=>setMajorsuccesses(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>What personal Constraints have you encountered in carrying out your job during the period of review?</label>
                                            <textarea rows={4} className="form-control" value={personalConstraint} onChange={(e)=>setPersonalConstraint(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Briefly mention only Major organizational constraints/weaknesses that have hindered your performance under the period of review.</label>
                                            <textarea rows={4} className="form-control" value={oraganizationalConstraint} onChange={(e)=>setOraganizationalConstraint(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>What possible solutions would you suggest to mitigate the constraints/weaknesses outlined above?</label>
                                            <textarea rows={4} className="form-control" value={solutionstoweakness} onChange={(e)=>setSolutionstoweakness(e.target.value)}  />
                                            </div>
                                        </Col>
                                    </Row>
                                    {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdateGeneralAssessment}
                                                        >
                                                        Save General Assessment responses
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdateGeneralAssessment}
                                                        >
                                                        Save General Assessment responses
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    </CardBody>
                                    </Card>
                                

                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Technical Job Deliverables ({paLines1.length})</h5>
                            <CardBody>
               
                                    {(paLines1.map((i,k)=>(
                                        <Row key={k}>
                                            
                                            <Col lg={8} className="mb-3">
                                               <h5>Line {k+1}</h5>
                                               <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">Key Result Area:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyResultArea}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Key Performance Indicator:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyPerformanceIndicator}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Planned Target</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.PlannedTarget}</Col>
                                               </Row>
                                          </Col>
                                          <Col lg={4} className="mb-3">
                                          <h5>&nbsp;</h5>
                                              {(phase == 'Annual') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                            <Row className='justify-content-center'>
                                                <Col>
                                                    <div className="align-items-center">   
                                                        <Button
                                                            type="button"
                                                            color="info"
                                                            className="btn-sm btn-rounded m-3"
                                                            onClick={()=>handleClickLineDetails1(k)}
                                                            >
                                                            Appraiser ratings
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                             )}  
                                               <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">Accomplishments:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.Accomplishments}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Percentage Rating</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.PercentageRating}</Col>
                                               </Row>
                                          </Col>
                                          <Col sm={12}><hr/></Col>
                       
                                        </Row>
                                    )))}
                                    </CardBody>
                                </Card>
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Competence Targets ({paLines2.length})</h5>
                                <CardBody>
                          
                          
                                    {(paLines2.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Competence Target for this period:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.Competencetargetsforthisperiod}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Critical Attributes Targetted:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.CriticalAttributestargetedundereachcompetence}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Key Performance Indicator:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyPerformanceIndicator}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(phase == 'Annual') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails2(k)}
                                                                >
                                                                Appraiser ratings
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}  
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Accomplishments:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.Accomplishments}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Percentage Rating</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.PercentageRating}</Col>
                                                </Row>
                                            </Col>
                                            <Col sm={12}><hr/></Col>                                            
                                        </Row>
                                    )))}
                                   
                                    </CardBody>
                                </Card>
                                
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Coaching and Mentorship: All Staff ({paLines3.length})</h5>
                                    <CardBody>
                            
                             
                                    {(paLines3.map((i,k)=>(
                                        <Row key={k}>
                                        <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">What coaching/Mentorship did you receive in this period that facilitated your performance or learning?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.CoachingMentorshipReceived}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Actual Coaching Results: What was achieved/What was the impact?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.ActualCoachingResults}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Gaps: What are the key identified gaps for follow-up in the next review?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.Gapsforrnextreview}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails3(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}  
                                                {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails3(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                
                                            </Col>
                                            <Col sm={12}><hr/></Col>  
                                        </Row>
                                    )))}
                                    </CardBody>
                                    <Row className='align-items-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-1"
                                                                onClick={()=>{tog_pa3(); clearData3();}}
                                                                >
                                                                Add Coaching and Mentorship Lines (All Staff)
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                </Card>

                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Coaching and Mentorship: Line Managers ({paLines4.length})</h5>
                                    <CardBody>
                            
                             
                                    {(paLines4.map((i,k)=>(
                                        <Row key={k}>
                                        <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">What coaching or mentorship did you offer to those reporting to you to facilitate their performance or learning?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LMCoachingMentoshipOffered}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Actual Coaching Results: What was achieved/What was the impact?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LMActualCoachingResults}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Gaps: What are the key identified gaps for followup in the next review?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LMGapsIdentified}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails4(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails4(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                  
                                            </Col>
                                            <Col sm={12}><hr/></Col>  
                                        </Row>
                                        
                                    )))}
                                    </CardBody>
                                    <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-1"
                                                                onClick={()=>{tog_pa4(); clearData4();}}
                                                                >
                                                                Add Coaching and Mentorship Lines (Line Managers)
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                </Card>
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Training Needs: Short Term Development Goals ({paLines5.length})</h5>
                                    <CardBody>
                            
                             
                                    {(paLines5.map((i,k)=>(
                                        <Row key={k}>
                                        <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">What learning and Development is required to support your current objectives and growth?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.ShortTermDevelopmentGoals}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Learning Methods: How will the Learning be achieved?</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.ShortTermLearningMethods}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Application: Please relate how the Learning and Development will be applied to the job/improve performance.</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.ShortTermApplication}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails5(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails5(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                  
                                            </Col>
                                            <Col sm={12}><hr/></Col>  
                                        </Row>
                                        
                                    )))}
                                    </CardBody>
                                    <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-1"
                                                                onClick={()=>{tog_pa5(); clearData5();}}
                                                                >
                                                                Add Short Term Development Goals
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                </Card>
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Training Needs: Long Term Development Goals ({paLines6.length})</h5>
                                    <CardBody>
                            
                             
                                    {(paLines6.map((i,k)=>(
                                        <Row key={k}>
                                        <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Career Development Goals</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LTCareerDevelopmentGoals}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Learning Methods:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LTLearningMethods}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Application/Outcome:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LTApplicationOutcome}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Timescale:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.LTTimescale}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails6(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails6(k)}
                                                                >
                                                                Edit/Delete Line
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}
                                                  
                                            </Col>
                                            <Col sm={12}><hr/></Col>  
                                        </Row>
                                        
                                    )))}
                                    </CardBody>
                                    <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-1"
                                                                onClick={()=>{tog_pa6(); clearData6();}}
                                                                >
                                                                Add Long Term Development Goals
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                </Card>
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">APPROVAL COMMENTS AND RECOMMENDATIONS</h5>
                                    <CardBody>
                         
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Employee comments</label>
                                            <textarea rows={2} disabled={true} className="form-control" value={appraiseeCommentsFullTerm} onChange={(e)=>setAppraiseeCommentsFullTerm(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Supervisor Comments</label>
                                            <textarea rows={2} disabled={true} className="form-control" value={appraiserCommentsFullTerm} onChange={(e)=>setAppraiserCommentsFullTerm(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Senior Manager Approval and Comments</label>
                                            <textarea rows={2} disabled={true} className="form-control" value={seniorManagerCommentsFullTerm} onChange={(e)=>setSeniorManagerCommentsFullTerm(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Director approval and comments</label>
                                            <textarea rows={2} disabled={true} className="form-control" value={directorCommentsFullTerm} onChange={(e)=>setDirectorCommentsFullTerm(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Suggested Action</label>
                                            <select disabled={true} className="form-select" value={actionType} onChange={(e)=>setActionType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {acType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                    </select>
                                            {/* <input type="text" disabled={true} className="form-control" defaultValue={actionType} onChange={(e)=>setActionType(e.target.value)}  /> */}
                                            </div>
                                        </Col>
                                    </Row>
                                    {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA2}
                                                        >
                                                        Save Approval Comments and Recommendations
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    {(whoAmI !== 'appraiser') && (whoAmI !== 'appraisee') && (ipaStatus == 'Pending Approval') && (seniormanagerstatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA3}
                                                        >
                                                        Save Approval Comments and Recommendations
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    {(whoAmI !== 'appraiser') && (whoAmI !== 'appraisee') && (ipaStatus == 'Pending Approval') && (directorStatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA4}
                                                        >
                                                        Save Approval Comments and Recommendations
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    {(whoAmI == 'appraisee') && (ipaStatus == 'Open') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA1}
                                                        >
                                                        Save Approval Comments and Recommendations
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    </CardBody>
                                    </Card>
                                    </Col>

                    <Col sm={3}></Col>
                    <Col sm="9">
                   

                                   
                     
                                <Row  className="justify-content-center">

                                    {reports.map((report, key)=>(  
                                <Col sm="4" key={key}>
                                    <Card>
                                        <CardBody>
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="avatar-xs me-3">
                                            <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                                                <i className={report.icon} />
                                            </span>
                                            </div>
                                            <h5 className="font-size-14 mb-0">{report.title}</h5>
                                        </div>
                                        <div className="text-muted mt-4">
                                            <h4>
                                            {report.value}{" "}
                                            <i className="mdi mdi-chevron-up ms-1 text-success" />
                                            </h4>
                                           
                                        </div>
                                        </CardBody>
                                    </Card>
                                    </Col>
                                    ))} 
                                </Row>
                                <Row  className="justify-content-center mb-3">

                               
                                {(whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" onClick={handleApproveAppraisal} >
                                                    Confirm Appraisal Review
                                                </Button>
                                            </div>
                                        </Col>
                                        {/* <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                     Print 
                                                </Button>
                                            </div>
                                        </Col>  */}
                                    </>  
                                )}

                                {(whoAmI !== 'appraiser') && (whoAmI !== 'appraisee') && (ipaStatus == 'Pending Approval') && (
                                    <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" onClick={handleApproveAppraisal} >
                                                    Confirm Appraisal Review
                                                </Button>
                                            </div>
                                        </Col>
                                        {/* <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                     Print 
                                                </Button>
                                            </div>
                                        </Col>  */}
                                    </>  
                                )}
                                
                                {(whoAmI == 'appraiser') && (ipaStatus == 'Approved') && (
                                    <>
                                        <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" onClick={handleApproveAppraisal} >
                                                    Confirm Probation
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" onClick={handlePrint}>
                                                    Close Appraisal
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="warning" type="button" className="btn" onClick={handlePrint}>
                                                    Extend Probation
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="warning" type="button" className="btn" onClick={handlePrint}>
                                                    Send to PIP
                                                </Button>
                                            </div>
                                        </Col>
                                        
                                        <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="danger" type="button" className="btn" onClick={handlePrint}>
                                                    Terminate Contract
                                                </Button>
                                            </div>
                                        </Col>
                                        {/* <Col md={3}>
                                            <div className="d-grid gap-2">
                                                <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                     Print 
                                                </Button>
                                            </div>
                                        </Col> */}
                                    </>  
                                )}
                                { (whoAmI == 'appraisee') && (ipaStatus == 'Open')&& (
                                    <>
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn" onClick={handleSendFulltermToAppraiser} >    
                                                Submit appraisal for review
                                            </Button>
                                        </div>
                                    </Col>
                            
                                    {/* <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                 Print 
                                            </Button>
                                        </div>
                                    </Col> */}
                                    </>
                                )}
                                {(phase == 'Mid-Year') && (whoAmI == 'appraisee') && (ipaStatus == 'Approved')&& (
                                    <>
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn" onClick={handleConvertToFullYear} >
                                                Convert to Full term appraisal
                                            </Button>
                                        </div>
                                    </Col>
                                    {/* <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                 Print 
                                            </Button>
                                        </div>
                                    </Col> */}
                                    </>
                                )}
                                    </Row>                                                
                                    <br/>

                </Col>
                </Row>

                </div>


                
                   

            </Container>
        </div>
        </LoadingOverlay>
        );
    }

export default ApproveFullTermsDetails;